import React, { useEffect, useMemo, useRef, useState, useImperativeHandle } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons"

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import "./custom.scss"

import "./styles.scss";
import { initialData_comp as initialData } from "./TableDataSet";

import update from 'immutability-helper'

import Rows from "./DnDTables/DataTable";

import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";

import { useTranslation } from 'react-i18next'

const P_TYPE = "Composition";
const API = "";

const COMTable = (props, _ref) => {
    const { t } = useTranslation(['page']);
    const { PROCode, unitCd,onOpen,RevCmptCheckList } = props;

    const [Hide, setHide] = useState(false);
    const [ModalOpen, SetModalOpen] = useState(false);
    const [TData, setTData] = useState([]);
    const [temp, setTemp] = useState([]);
    const modalData = useRef({ modalType: null });

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        initial: () => {
            setTData(TD => []);
        },
        add: () => {
            setTData(TP => update(TP, {
                $push: [initialData]
            }))
        },
        move: ({ dragIndex, hoverIndex }) => {
            // setTData(TP => update(TP, {
            //     $splice: [
            //         [dragIndex, 1],
            //         [hoverIndex, 0, TP[dragIndex]],
            //     ]
            // }))
        },
        remove: (idx) => {
            setTData(TP => update(TP, {
                $splice: [[idx, 1]]
            }));
        },
        loadData: (data) => {
            let newVal = [];
            let tmp;
            let fidx;
            data.map(d => {
                tmp = initialData;
                Object.keys(d).map(k => {
                    fidx = tmp.findIndex(i => i.name === k);
                    if (fidx > -1) tmp = update(tmp, {
                        [fidx]: { $merge: { value: d[k] } }
                    })
                })
                newVal = [...newVal, [...tmp]]
            })
            setTData(newVal);
            setTemp(newVal);
        },
        preOnData: ({data}) =>{
            setTData(data);
        },
        resetData: () =>{
            setTData(temp);
        },
    }))


    const onOpenWrapper = (vv,index,dataIndex,sheetType) => {
        onOpen(vv,index,dataIndex,sheetType,TData,'COM');
    }
    const HandleHide = () => {
        setHide(!Hide);
    };

    const modalRender = () => {
        return <Confirm onClose={() => SetModalOpen(false)} onConfirm={() => deleteRowConfirm()}>
            <p>{t("delete")}</p>
        </Confirm>
    }
    const modal = useMemo(modalRender, [ModalOpen])

    
    const deleteRowConfirm = () => {
        const { index } = modalData.current;

        setTData(TP => update(TP,
            {

                $splice: [[index, 1]]
            }
        ))
        SetModalOpen(false);
    }

    const renderFunc = () => {
        try {
            return TData.map((v, i) => {
                return <Rows
                    api={API}
                    // code={k.uniqCode}
                    PROCode={PROCode}
                    index={i}
                    rowData={v}
                    key={"comp" + i}
                    onOpen = {onOpenWrapper}
                    dataIndex={i}
                    sheetType={"C"}
                    RevCmptCheckList={RevCmptCheckList}
                />
            })
        } catch (e) {
            return null;
        }
    }
    
    return unitCd.match(/(USP01|DSP01)/) !== null && 
    // return false && 
        <section className="detail">
        <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
            <h1 className={"title "} onClick={HandleHide}>{P_TYPE.toUpperCase()} <FontAwesomeIcon icon={faAngleUp} /></h1>
            <div className={"data_table "}>
                <DndProvider backend={HTML5Backend}>
                    <table>
                        <colgroup>
                            <col width="2%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="10%"></col>
                            <col width="2%"></col>
                            <col width="0.5%"></col>
                            <col width="2%"></col>
                            <col width="12%"></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Parameter Code</th>
                                <th>Material Code</th>
                                <th>Component</th>
                                <th>Main/Alter</th>
                                <th>Concentration</th>
                                <th colSpan="3">Unit</th>
                                <th>Reference</th>
                            </tr>

                        </thead>
                        <tbody>
                            {renderFunc()}
                        </tbody>
                    </table>
                </DndProvider>
            </div>
        </div>
        {ModalOpen &&
            <ModalPortal>
                {modal}
            </ModalPortal>
        }
    </section>
}

export default React.memo(React.forwardRef(COMTable));